"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventsCalendarPost = exports.isTilePuzzlePost = exports.isMultiChoicePost = exports.isVoteSliderPost = exports.isThisOrThatPost = exports.isVideoPost = exports.isShopLinkPost = exports.isArticlePost = exports.isPostType = exports.isPostData = exports.isButtonType = exports.isActionType = exports.PORTAL_POST_ID_MAX_LENGTH = exports.POP_TEXT_V2_ROW_SEPARATOR = void 0;
exports.popTextV2ToPopText = popTextV2ToPopText;
const Translations_1 = require("../../cms/Translations");
/**
 * Marker used inside a PopTextV2 stored text to delimit virtual rows.
 * Changing this value affects how PopTextV2 is rendered, edited and converted
 * to PopText, so any place that splits/joins rows must import this constant.
 */
exports.POP_TEXT_V2_ROW_SEPARATOR = '<br>';
/**
 * Maximum allowed length for a portal post `id`. Longer ids break the CMS
 * client UI, so the limit is enforced both client-side (input) and server-side
 * (create body + update URL param, which upserts). Shared here so the two
 * never drift apart.
 */
exports.PORTAL_POST_ID_MAX_LENGTH = 70;
const isActionType = (action, type) => {
    return action.$type === type;
};
exports.isActionType = isActionType;
const isButtonType = (button, actionType) => {
    return (0, exports.isActionType)(button.action, actionType);
};
exports.isButtonType = isButtonType;
const isPostData = (data) => {
    return (data !== null &&
        typeof data === 'object' &&
        '$type' in data &&
        'size' in data);
};
exports.isPostData = isPostData;
const isPostType = (type) => {
    return (data) => {
        return (0, exports.isPostData)(data) && data.$type === type;
    };
};
exports.isPostType = isPostType;
exports.isArticlePost = (0, exports.isPostType)('Article');
exports.isShopLinkPost = (0, exports.isPostType)('ShopLink');
exports.isVideoPost = (0, exports.isPostType)('Video');
exports.isThisOrThatPost = (0, exports.isPostType)('ThisOrThatPoll');
exports.isVoteSliderPost = (0, exports.isPostType)('VoteSliderPoll');
exports.isMultiChoicePost = (0, exports.isPostType)('MultiChoicePoll');
exports.isTilePuzzlePost = (0, exports.isPostType)('TilePuzzle');
exports.isEventsCalendarPost = (0, exports.isPostType)('EventsCalendar');
/**
 * Splits a translation table where each language value contains row-separator
 * markers into one translation table per row. Row count is uniform across
 * languages, so the first language's piece count is used.
 */
function splitTranslationTableByBr(table) {
    const languages = Object.values(Translations_1.LanguageType).filter((lang) => lang in table);
    if (languages.length === 0) {
        return [table];
    }
    const rowCount = (table[languages[0]] ?? '').split(exports.POP_TEXT_V2_ROW_SEPARATOR).length;
    const rows = [];
    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        const row = { $type: 'TranslationTable' };
        if (table.$key !== undefined) {
            row.$key = table.$key;
        }
        for (const language of languages) {
            const pieces = (table[language] ?? '').split(exports.POP_TEXT_V2_ROW_SEPARATOR);
            row[language] = pieces[rowIndex] ?? '';
        }
        rows.push(row);
    }
    return rows;
}
function popTextV2ToPopText(popTextV2) {
    // After PortalFeedService.translate() runs, TranslationTable values are
    // replaced by the resolved string for the requested language. In that case
    // `text` is a plain string and must be split directly; otherwise we split
    // each language inside the TranslationTable.
    const text = popTextV2.text;
    const rowTexts = typeof text === 'string'
        ? text.split(exports.POP_TEXT_V2_ROW_SEPARATOR)
        : (0, Translations_1.isTranslationTable)(text)
            ? splitTranslationTableByBr(text)
            : [text];
    return {
        position: popTextV2.position,
        animated: popTextV2.animated,
        rows: rowTexts.map((rowText, index) => {
            const swap = index % 2 === 1;
            return {
                text: rowText,
                fontSize: popTextV2.fontSize,
                textColor: swap
                    ? popTextV2.backgroundColor
                    : popTextV2.textColor,
                backgroundColor: swap
                    ? popTextV2.textColor
                    : popTextV2.backgroundColor,
            };
        }),
    };
}
